@if (!useSummaryView) {
  @if (!field.hidden) {
    <div animate.enter="fade-in" class="flex flex-col w-full">
      <mat-label class="mr-2 font-medium">{{ field.label | localize }}</mat-label>
      @if (!field.control.disabled) {
        <mat-chip-listbox class="p-4" selectable="false">
          @for (col of columns; track col) {
            <mat-chip class="flex flex-row items-center">
              <span class="mb-1">{{ col.name }}</span>
              <button matChipTrailingIcon (click)="add(col)">
                <mat-icon svgIcon="mat_outline:add"></mat-icon>
              </button>
            </mat-chip>
          }
        </mat-chip-listbox>
      }
      <div class="flex flex-row items-center w-full">
        <mat-form-field class="w-full">
                <input matInput [formControl]="field.control" [placeholder]="field.placeholder | localize" [ngClass]="{
                        'text-left': field.browserOpts.alignment === 'LEFT',
                        'text-center': field.browserOpts.alignment === 'CENTER',
                        'text-right': field.browserOpts.alignment === 'RIGHT',
                        'uppercase': field.transform === 'UPPERCASE',
                        'lowercase': field.transform === 'LOWERCASE'
                    }" [readonly]="field.readonly" [required]="field.required" />
            @if (field.hint) {
              <mat-hint>{{ field.hint | localize }}</mat-hint>
            }
            @if (field.control.hasError('required') && !field.readonly) {
              <mat-error>
                {{ 'errorRequiredField' | transloco }}
              </mat-error>
            }
            @if (field.control.hasError('minlength') && !field.readonly) {
              <mat-error>
                {{ 'errorMinLengthField' | transloco:{ requiredLength: field.control.errors.minlength.requiredLength } }}
              </mat-error>
            }
            @if (field.control.hasError('maxlength') && !field.readonly) {
              <mat-error>
                {{ 'errorMaxLengthField' | transloco:{ requiredLength: field.control.errors.maxlength.requiredLength } }}
              </mat-error>
            }
          </mat-form-field>
        </div>
      </div>
    }
  } @else {
    {{ field.control.value }}
  }

